import { Divider, Grid } from '@mui/material';
import { FormikErrors, FormikTouched } from 'formik';
import { FiltersFormCohabitation } from 'cohabitation/view-models/filter-cohabitation';
import KindStreetList from '../kind-street-list';
import CohabitationNameAutoComplete from './autocomplete-cohabitation';
import StreetCohabitationAutoComplete from './autocomplete-street';

interface FiltersCohabitationStreetProps {
  onChange: (
    key: keyof FiltersFormCohabitation,
    value: FiltersFormCohabitation[keyof FiltersFormCohabitation]
  ) => void;
  onChangeValues: (values: FiltersFormCohabitation) => void;
  values: FiltersFormCohabitation;
  errors?: FormikErrors<FiltersFormCohabitation>;
  touched?: FormikTouched<FiltersFormCohabitation>;
}

const FilterCohabitationStreet = ({
  values,
  onChange,
  onChangeValues,
  errors,
  touched,
}: FiltersCohabitationStreetProps): React.ReactElement => {
  return (
    <Grid container item xs={12} spacing={2}>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <CohabitationNameAutoComplete
          aria-label="Nome convivenza"
          value={values?.cohabitationName || null}
          error={touched?.cohabitationName && Boolean(errors?.cohabitationName)}
          onChange={(value) =>
            onChangeValues({
              page: 0,
              rowsPerPage: 10,
              orders: {},
              cohabitationName: value,
              codeMunicipality: (value?.id as string) || '',
            })
          }
        />
      </Grid>
      <Grid item container spacing={2} xs={12}>
        <Grid item xs={12} md={3}>
          <KindStreetList
            value={values?.kindStreet || ''}
            onChange={(event) => onChange('kindStreet', event.target.value)}
          />
        </Grid>
        <Grid item xs={12} md={9}>
          <StreetCohabitationAutoComplete
            value={values?.cohabitationStreet || null}
            error={touched?.cohabitationStreet && Boolean(errors?.cohabitationStreet)}
            onChange={(item) =>
              onChangeValues({
                page: 0,
                rowsPerPage: 10,
                orders: {},
                cohabitationStreet: item,
                kindStreet: item?.kindStreet,
                codeMunicipality: item?.cohabitationId,
              })
            }
          />
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
    </Grid>
  );
};

FilterCohabitationStreet.displayName = 'Filters Cohabitation component';

export default FilterCohabitationStreet;
